module.exports = __webpack_public_path__ + "static/media/two-butterflies.4e8a7a93.jpg";